import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppSettingsService } from './app-settings/app-settings.service';
import { BalloonComponent } from './balloon/balloon.component';
import { ClickOutsideDirective } from 'angular2-click-outside/index';
import {
	ModalComponent,
	ModalTitleComponent,
	ModalContentComponent,
	ModalFooterComponent
} from './modal/modal.component';
import { TabsComponent } from './tabs/tabs.component';
import { RouterModule } from '@angular/router';
import { CardComponent } from './card/card.component';
import { AutoSelectDirective } from './auto-select.directive';
import { SelectComponent } from './select/select.component';
import { ToOptionsPipe } from './select/to-options.pipe';
import { DaterangeComponent } from './daterange/daterange.component';
import { MyDateRangePickerModule } from 'mydaterangepicker';
import { DefaultRangeService } from './daterange/default-range.service';
import { CurrencyFormatPipe } from './currency-format.pipe';
import { CurrencyCurrentComponent } from './currency-current/currency-current.component';
import { FormsModule } from '@angular/forms';
import { ValidationBalloonComponent } from './validation-balloon/validation-balloon.component';
import { PaginationComponent } from './pagination/pagination.component';
import { ValidateErrorService } from './validate-error.service';
import { PickmeupService } from './pickmeup.service';
import { CurrencyService } from './currency.service';
import { HintComponent } from './hint/hint.component';
import { TableComponent } from './table/table.component';
import { KeysPipe } from './keys.pipe';
import { DisabledOuterScrollDirective } from './disabled-outer-scroll.directive';
import { TelInputComponent } from './tel-input/tel-input.component';
import { TextMaskModule } from 'angular2-text-mask';
import { SelectModule } from 'ng-select';
import { NumberCurryingPipe } from './number-currying.pipe';

@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		MyDateRangePickerModule,
		FormsModule,
		TextMaskModule,
		SelectModule
	],
	declarations: [
		BalloonComponent,
		ClickOutsideDirective,
		ModalComponent,
		ModalTitleComponent,
		ModalContentComponent,
		ModalFooterComponent,
		TabsComponent,
		CardComponent,
		AutoSelectDirective,
		SelectComponent,
		ToOptionsPipe,
		DaterangeComponent,
		CurrencyFormatPipe,
		CurrencyCurrentComponent,
		ValidationBalloonComponent,
		PaginationComponent,
		HintComponent,
		TableComponent,
		KeysPipe,
		DisabledOuterScrollDirective,
		TelInputComponent,
		NumberCurryingPipe
	],
	exports: [
		BalloonComponent,
		ModalComponent,
		ModalTitleComponent,
		ModalContentComponent,
		ModalFooterComponent,
		TabsComponent,
		CardComponent,
		AutoSelectDirective,
		SelectComponent,
		ToOptionsPipe,
		CurrencyFormatPipe,
		CurrencyCurrentComponent,
		DaterangeComponent,
		ValidationBalloonComponent,
		PaginationComponent,
		HintComponent,
		TableComponent,
		DisabledOuterScrollDirective,
		TelInputComponent,
		NumberCurryingPipe
	]
})
export class SharedModule {

	static forRoot(): ModuleWithProviders {
		return {
			ngModule: SharedModule,
			providers: [
				AppSettingsService,
				CurrencyService,
				DefaultRangeService,
				CurrencyFormatPipe,
				ValidateErrorService,
				PickmeupService
			]
		}
	}

	constructor(
		private pickmeupService: PickmeupService
	) {
		pickmeupService.setDefaultOptions();
	}
}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/shared/shared.module.ts